import React from "react";

const X = () => {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="close-icon__fill"
        d="M1.476.612L4 3.136 6.524.612l.864.864L4.864 4l2.524 2.524-.864.864L4 4.864 1.476 7.388l-.864-.864L3.136 4 .612 1.476z"
        fill="#FFF"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default X;
